import React from 'react';
import { AppBar, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Toolbar, Typography } from "@material-ui/core";
import { MatIconService } from "../../../shared/services/theme/matIconService";
import LayoutService from "../../../shared/services/layoutService";

class TransactionDetailEditConfirmComponent extends React.Component {
    render() {
        const { classes } = this.props;

        return (
            <div>
                <Dialog
                    open={this.props.open || false}
                    onClose={this.props.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <AppBar position="static">
                            <Toolbar>
                                <Typography variant="h6" className={classes.root}>Compliance Report Warning</Typography>
                                {LayoutService.getIconButton(false, MatIconService.OK, "Edit", this.props.handleEditConfirm, "inherit", "keyActionEdit")}
                                {LayoutService.getIconButton(false, MatIconService.CANCEL, "Cancel", this.props.handleEditDismiss, "secondary", "keyActionCancel")}
                            </Toolbar>
                        </AppBar>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <Box style={{ paddingLeft: 16, paddingRight: 32, paddingTop: 8, paddingBottom: 32, }}  >
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                       
                                        <Typography variant="h6" className={classes.root} align="center">
                                            { this.props?.count > 0 ? this.props.count +' Records Selected for Edits have already been included on a Submitted & Approved Compliance Report. Do you wish to proceed with these Updates, and adjust already Submitted Transactions?': this.props?.hasreportreferences ? 'This transaction has been included on a report with a final disposition flag. Are you sure you want to edit this transaction? For additional details please check the Report References tab.' : ''}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}

export default LayoutService.getHocComponenet(TransactionDetailEditConfirmComponent);